module.exports = __webpack_public_path__ + "img/model_17_zh.4f716589.jpg";